import { Field as Fieldmik, Formik } from 'formik';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, Form as FormUi, Segment } from 'semantic-ui-react';
import * as yup from 'yup';

import { MyTextArea } from '../../formikInput/input';

import CityDropdown from '../../dropdowns/cityDropdown';
import LoadingPlaceholder from '../../placeholder/loadingPlaceholder';
import AddTitleBar from '../../titleBar/addTitleBar';

import {
    FIELD_IS_REQUIRED, INVALID_EMAIL, INVALID_FIELD,
    INVALID_GST_NUMBER, INVALID_LAND_LINE_NUMBER, INVALID_LATITUDE,
    INVALID_LONGITUDE, INVALID_MOBILE_NO, INVALID_NAME,
    INVALID_PAN_NO, INVALID_PIN_CODE
} from '../../../config/const';
import { getConsignor, updateConsignor } from '../../../redux/actions/consignorMasterActions ';
import { AllRegex } from '../../../utils/validation';
import { COOKIE_CUSTOMER_NO, COOKIE_USER_ID } from '../../utils/constants';

const AddConsignor = (props) => {
    const { getConsignor, updateConsignor, consignorLoading, consignorData } = props;

    useEffect(() => {
        const id = props.location.state.id
        getConsignor(id)
    }, [])

    if (consignorLoading) {
        return (
            <React.Fragment>
                <LoadingPlaceholder />
            </React.Fragment>
        )
    } else {
        const initialValues = {
            checkPointMasterId: consignorData ? consignorData[0].checkPointMasterId : "",
            consignorCode: consignorData ? consignorData[0].consignorCode : "",
            consignorName: consignorData ? consignorData[0].consignorName : "",
            email: consignorData ? consignorData[0].email : "",
            phone: consignorData ? consignorData[0].phone : "",
            address: consignorData ? consignorData[0].address : "",
            cityId: consignorData ? consignorData[0].cityId : "",
            cityName: consignorData ? consignorData[0].cityName : "",
            checkPointLattitude: consignorData ? consignorData[0].checkPointLattitude : "",
            checkPointLongitude: consignorData ? consignorData[0].checkPointLongitude : "",
            gstNumber: consignorData && consignorData[0].gstNumber || "",
            pincode: consignorData ? consignorData[0].pincode : "",
            contactPersonName: consignorData ? consignorData[0].contactPersonName : "",
            landLineNo: consignorData ? consignorData[0].landLineNo : "",
        }

        const validateSchema = yup.object().shape({
            consignorCode: yup.string().nullable(),
            consignorName: yup.string().required(FIELD_IS_REQUIRED),
            address: yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.Address, INVALID_FIELD.INVALID_ADDRESS),
            email: yup.string().optional().nullable().matches(AllRegex.Email, INVALID_EMAIL),
            contactPersonName: yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.Name, INVALID_NAME),
            pincode: yup.string().matches(AllRegex.Pincode, INVALID_PIN_CODE).required(FIELD_IS_REQUIRED),
            landLineNo: yup.string().matches(AllRegex.landLineNo, INVALID_LAND_LINE_NUMBER).nullable(),
            checkPointLattitude: yup.string().matches(AllRegex.Latitude, INVALID_LATITUDE).optional().nullable(),
            checkPointLongitude: yup.string().matches(AllRegex.Longitude, INVALID_LONGITUDE).optional().nullable(),
            gstNumber: yup.string().matches(AllRegex.GSTIN, INVALID_GST_NUMBER).nullable(),
            panNumber: yup.string().matches(AllRegex.PANIN, INVALID_PAN_NO).optional().nullable(),
            cityId: yup.string().optional().nullable(),
            phone: yup.string().matches(AllRegex.MobileNumber, INVALID_MOBILE_NO).required(FIELD_IS_REQUIRED).nullable(),
        })

        const onSubmit = (values, onSubmitProps) => {
            const customerNumber = COOKIE_CUSTOMER_NO;
            const userId = COOKIE_USER_ID;
            const id = consignorData[0].consignorId

            const updateConsignorData = {
                checkPointMasterId: values.checkPointMasterId,
                address: values.address,
                checkPointLattitude: values.checkPointLattitude,
                checkPointLongitude: values.checkPointLongitude,
                cityId: values.cityId,
                consignorCode: values.consignorCode,
                consignorName: values.consignorName,
                customerNo: customerNumber,
                customerNumber: customerNumber,
                customer_no: customerNumber,
                email: values.email,
                gstNumber: values.gstNumber,
                panNumber: values.panNumber,
                phone: values.phone,
                pincode: values.pincode,
                contactPersonName: values.contactPersonName,
                landLineNo: values.landLineNo,
                state: "",
                userId: userId,
                user_id: userId,
                consignorId: id
            };

            updateConsignor(updateConsignorData, id).then(() => {
                setTimeout(() => { onSubmitProps.setSubmitting(false) }, 4000)
            });
        };

        return (
            <React.Fragment>
                <AddTitleBar title="Edit Consignor" LinkName="/consignor" />
                <div className="m-2">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validateSchema}
                        onSubmit={onSubmit}
                    >
                        {({ touched, errors, values, isSubmitting, handleSubmit }) => (
                            <>
                                <Segment>
                                    <div className="ui form tiny">
                                        <FormUi.Group>
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Consignor Code</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="consignorCode" placeholder="Code" />
                                                {touched.consignorCode && errors.consignorCode ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.consignorCode}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Consignor Name<span className='mandatory-star'> *</span></label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="consignorName" placeholder="Type Name" />
                                                {touched.consignorName && errors.consignorName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.consignorName}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group >
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Email Id</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="email" placeholder="Enter Email Id" />
                                                {touched.email && errors.email ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.email}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Mobile No</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="phone" placeholder="Enter Mobile No" />
                                                {touched.phone && errors.phone ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.phone}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group >
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">LandLine No</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="landLineNo" placeholder="Enter LandLine No" />
                                                {touched.landLineNo && errors.landLineNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.landLineNo}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Contact Person Name</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="contactPersonName" placeholder="Enter Mobile No" />
                                                {touched.contactPersonName && errors.contactPersonName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.contactPersonName}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group >
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Company Address<span className='mandatory-star'> *</span></label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="address" placeholder="Enter Address" component={MyTextArea} />
                                                {touched.address && errors.address ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.address}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">City</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="cityId" placeholder={values.cityName} component={CityDropdown} value={values.cityId} cityId={values.cityId} />
                                                {touched.cityId && errors.cityId ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.cityId}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group >
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Latitude</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="checkPointLattitude" placeholder="Enter Latitude" />
                                                {touched.checkPointLattitude && errors.checkPointLattitude ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.checkPointLattitude}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Longitude</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="checkPointLongitude" placeholder="Enter Longitude" />
                                                {touched.checkPointLongitude && errors.checkPointLongitude ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.checkPointLongitude}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group >
                                            {console.log(errors)}
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">GST No<span className='mandatory-star'> *</span></label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">

                                                <Fieldmik name="gstNumber" placeholder="Enter GST No" />
                                                {touched.gstNumber && errors.gstNumber ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.gstNumber}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Pincode<span className='mandatory-star'> *</span></label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="pincode" placeholder="Enter Pincode" />
                                                {touched.pincode && errors.pincode ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.pincode}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                    </div>
                                </Segment>

                                <center><Button disabled={isSubmitting} onClick={handleSubmit} size='mini' primary type='submit'>Submit</Button></center>
                            </>
                        )}
                    </Formik>
                </div>
            </React.Fragment>
        )
    }
}

const mapStatetoProps = (state) => ({
    consignorData: state.getConsignorData.consignor.resultSet,
    consignorLoading: state.getConsignorData.isLoading
})

export default connect(mapStatetoProps, { updateConsignor, getConsignor })(AddConsignor)
